import { useFetch } from "@/lib/useFetch";
import { PageHeader, Spinner } from "@/app/ui";
import { fmtDate } from "@/lib/format";
import { ShieldCheck } from "lucide-react";

export default function AuditLog() {
  const { data, loading } = useFetch("/audit-logs");
  if (loading) return <Spinner />;
  const items = data?.items || [];
  return (
    <div className="animate-fade-up">
      <PageHeader title="Audit Trail" description="A record of important actions in your workspace." />
      <div className="amden-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-left"><tr>
            <th className="px-4 py-3 font-semibold">Action</th><th className="px-4 py-3 font-semibold">By</th>
            <th className="px-4 py-3 font-semibold hidden sm:table-cell">Target</th><th className="px-4 py-3 font-semibold text-right">When</th></tr></thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-t border-slate-100">
                <td className="px-4 py-3 font-medium text-navy">{a.action}</td>
                <td className="px-4 py-3 text-slate-600">{a.actor_email} <span className="text-xs text-slate-400">({a.actor_role})</span></td>
                <td className="px-4 py-3 text-slate-500 hidden sm:table-cell font-mono text-xs">{a.target_type || "—"}</td>
                <td className="px-4 py-3 text-right text-slate-500">{fmtDate(a.created_at)}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={4} className="px-4 py-10 text-center text-slate-400">No activity recorded yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
